export default "__VITE_ASSET__B61Y49pP__"